import React, { useState, useEffect } from 'react';
import { getStatuses, createStatus, updateStatus, deleteStatus } from '../services/api';

const StatusManagement = () => {
  const [statuses, setStatuses] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    category: 'Disponível',
    color: '#4CAF50'
  });

  useEffect(() => {
    fetchStatuses();
  }, []);

  const fetchStatuses = async () => {
    try {
      const response = await getStatuses();
      setStatuses(response.data);
    } catch (error) {
      console.error('Error fetching statuses:', error);
    }
  };

  const handleSubmit = async () => {
    if (!formData.name.trim()) return;

    try {
      if (editingId) {
        // Update existing
        const response = await updateStatus(editingId, formData);
        setStatuses(statuses.map(s => s.id === editingId ? response.data : s));
        alert('Status atualizado com sucesso!');
      } else {
        // Create new
        const response = await createStatus(formData);
        setStatuses([...statuses, response.data]);
        alert('Status criado com sucesso!');
      }
      resetForm();
    } catch (error) {
      console.error('Error saving status:', error);
      alert('Erro ao salvar status: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleEdit = (status) => {
    setEditingId(status.id);
    setFormData({
      name: status.name,
      category: status.category,
      color: status.color
    });
    // Scroll to form
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const resetForm = () => {
    setEditingId(null);
    setFormData({
      name: '',
      category: 'Disponível',
      color: '#4CAF50'
    });
  };

  const handleDeleteStatus = async (id) => {
    if (id <= 3) {
      alert('Não é possível deletar os status base (Disponível, Reservado, Bloqueado)');
      return;
    }

    if (!window.confirm('Tem certeza que deseja deletar este status?')) {
      return;
    }

    try {
      await deleteStatus(id);
      setStatuses(statuses.filter(status => status.id !== id));
    } catch (error) {
      console.error('Error deleting status:', error);
      alert('Erro ao deletar status');
    }
  };

  const getContrastColor = (hexColor) => {
    const r = parseInt(hexColor.substr(1, 2), 16);
    const g = parseInt(hexColor.substr(3, 2), 16);
    const b = parseInt(hexColor.substr(5, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000000' : '#FFFFFF';
  };

  return (
    <div className="container pb-20 md:pb-4 pb-safe mt-4">
      <h2 className="mb-4">Gerenciamento de Status</h2>

      <div className="card mb-4 border-primary">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">{editingId ? 'Editar Status' : 'Adicionar Novo Status'}</h5>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Nome</label>
              <input
                type="text"
                className="form-control"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Ex: Higienizando"
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Categoria Base</label>
              <select
                className="form-select"
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              >
                <option value="Disponível">Disponível</option>
                <option value="Reservado">Reservado</option>
                <option value="Bloqueado">Bloqueado</option>
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label">Cor</label>
              <div className="input-group">
                <input
                  type="color"
                  className="form-control form-control-color"
                  value={formData.color}
                  onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                  title="Escolha a cor"
                />
                <button
                  className={`btn ${editingId ? 'btn-warning' : 'btn-success'}`}
                  onClick={handleSubmit}
                >
                  {editingId ? 'Atualizar' : 'Adicionar'}
                </button>
                {editingId && (
                  <button
                    className="btn btn-secondary"
                    onClick={resetForm}
                  >
                    Cancelar
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-hover align-middle">
          {/* ... table content ... */}
          <thead className="table-light">
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>Categoria</th>
              <th>Cor</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {statuses.map(status => (
              <tr key={status.id} className={editingId === status.id ? 'table-warning' : ''}>
                <td>{status.id}</td>
                <td>{status.name}</td>
                <td>{status.category}</td>
                <td>
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: status.color,
                      color: getContrastColor(status.color),
                      padding: '0.6rem 1rem',
                      fontSize: '0.9rem'
                    }}
                  >
                    {status.color}
                  </span>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => handleEdit(status)}
                    title="Editar"
                  >
                    <i className="bi bi-pencil-fill"></i>
                  </button>

                  {status.id > 3 ? (
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDeleteStatus(status.id)}
                      title="Excluir"
                    >
                      <i className="bi bi-trash-fill"></i>
                    </button>
                  ) : (
                    <span className="badge bg-secondary" title="Status Padrão do Sistema">
                      <i className="bi bi-lock-fill"></i>
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Spacer para garantir que o rodapé não esconda o conteúdo */}
      <div style={{ height: '100px' }}></div>
    </div>
  );
};

export default StatusManagement;
